<div class="modal-header">
  <h4 class="modal-title">{{title | translate}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <i class="ico-close sz-xs"></i>
  </button>
</div>

<div class="modal-body">
  <p>{{message | translate}}</p>
</div>

<div class="modal-footer">
  <button type="button" class="form__action--primary" (click)="activeModal.close()" role="button">
    <i class="ico-check"></i>
    {{'confirm.yes' | translate}}
  </button>
  <button type="button" class="form__action--danger" (click)="activeModal.dismiss()" role="button">
    <i class="ico-close"></i>
    {{'confirm.no' | translate}}
  </button>
</div>
